<template>
  <transition name="fade">
    <b-card no-body class="w-100">
      <div slot="header">
        {{ title }}
      </div>

      <b-card-body>
        <div class="chart-container">
          <h6>By country</h6>
          <bar-chart :items="countriesFormatted" />
        </div>

        <div class="chart-container">
          <h6>By port</h6>
          <bar-chart :items="portsFormatted" />
        </div>
      </b-card-body>
    </b-card>
  </transition>
</template>

<script>
  import BarChart from '../widgets/BarChart'
  import getNested from 'lodash-es/get'

  export default {
    name: 'directions-stat',

    components: {
      BarChart,
    },

    props: {
      title: {
        type: String,
        default: () => 'No title',
      },

      countries: {
        type: Array,
        default: () => [],
      },

      ports: {
        type: Array,
        default: () => [],
      },
    },

    data() {
      return {};
    },

    methods: {
      // ...
    },

    computed: {
      countriesFormatted() {
        return this.countries.map(item => ({
          title: getNested(item, 'country', '--'),
          volume: getNested(item, 'volume', 0),
        }));
      },

      portsFormatted() {
        return this.ports.map(item => ({
          title: getNested(item, 'portName', '--'),
          volume: getNested(item, 'volume', 0),
        }));
      },
    },
  }
</script>

<style scoped>
  .chart-container {
    margin-bottom: 20px;
    height: 50%;
  }

  .chart-container:not(:last-child) {
    border-bottom: 1px solid gray;
  }
</style>
